// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"59fd8a8f","106":"7fe730a5","120":"154a2137","239":"69c23b37","266":"3665f0bb","392":"baefd632","399":"ce291729","422":"9ee553ed","455":"ad41e016","480":"691a84a4","559":"77a3a3d3","872":"ef4c881b","977":"77f2983e"}[chunkId] + ".chunk.js";
};